'use client';

import Link from 'next/link';
import { Settings02, Star01 } from '@goodneighbor/ui/icons/untitled';
import styles from './campaignHeader.module.scss';

export function VolunteerDesktopMenuItems() {
  return (
    <>
      <Link href="/volunteer/account" className={styles.accountMenuItem}>
        Account
      </Link>
      <Link href="/volunteer/my-events" className={styles.accountMenuItem}>
        My Events
      </Link>
    </>
  );
}

export function VolunteerMobileNavItems({
  onNavigate
}: {
  onNavigate: () => void;
}) {
  return (
    <ul className={styles.mobileNavList}>
      <li>
        <Link
          href="/volunteer/account"
          className={styles.mobileNavLinkWithIcon}
          onClick={onNavigate}
        >
          <Settings02 className={styles.mobileNavIcon} />
          Account
        </Link>
      </li>
      <li>
        <Link
          href="/volunteer/my-events"
          className={styles.mobileNavLinkWithIcon}
          onClick={onNavigate}
        >
          <Star01 className={styles.mobileNavIcon} />
          My Events
        </Link>
      </li>
    </ul>
  );
}
